import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class Calculator extends React.Component {

    

   

    calculate(data) {
        // console.log(values)
        let total = 0
        let disountRate = 0
        let taxRate = 0
        let totalNeedTax = 0
        let totalNeedDiscount = 0
        let discount = 0
        let tax = 0
        let subTotal

        let values = data?.values

        if (values?.list) {
            for (let i = 0; i < values.list.length; i++) {
                const value = values.list[i];
                // console.log(value)
                if (!value.tax && !value.discount) {
                    total = total + value.amount
                    if (!value.taxFree) {
                        totalNeedTax = totalNeedTax + value.amount
                    }
                    if (!value.discountFree) {
                        totalNeedDiscount = totalNeedDiscount + value.amount
                    }
                }
                if (value.tax) {
                    if (typeof value.amount == "string") {
                        taxRate = Number(value.amount.replace('%', '')) / 100
                    } else {
                        taxRate = Number(value.amount) / 100
                    }
                
                }
                if (value.discount) {
                    if (typeof value.amount == "string") {
                        disountRate = Number(value.amount.replace('%', '')) / 100
                    } else {
                        disountRate = Number(value.amount) / 100
                    }
                }
            }

            subTotal = total
            discount = (totalNeedDiscount * disountRate)
            tax = ((totalNeedTax-discount) * taxRate)

            total = total - discount + tax
        }
 

        return { total, subTotal, discount, tax }

    }

    render() {
        return (
            <div className=' '>
                <div className=' p-3' style={{  color: '#3b3a40', minHeight: 35 }}>
                    <p className=" text-bold" style={{ color: '#000', fontSize: 13 }}>Subtotal: {this.calculate(this.props.fullValues).subTotal ? this.calculate(this.props.fullValues).subTotal.toFixed(2) : 0}</p>
                    <p className="mt-2 text-bold" style={{ color: '#d97706', fontSize: 13 }}>Discount: {this.calculate(this.props.fullValues).discount ? this.calculate(this.props.fullValues).discount.toFixed(2) : 0}</p>
                    <p className="mt-2 text-bold" style={{ fontSize: 13 }} >GST: {this.calculate(this.props.fullValues).tax ? this.calculate(this.props.fullValues).tax.toFixed(2) : 0}</p>
                    <p className="mt-2 pt-1" style={{ fontWeight: 'bold', borderTop: '1px solid #202020' }}>Total: {this.calculate(this.props.fullValues).total ? this.calculate(this.props.fullValues).total.toFixed(2) : 0}</p>

                </div>
            </div>
        );
    }
}

export default Calculator;
